module.exports = __webpack_public_path__ + "media/images/icons/outlined/appstore-eab4d73f334900179121c51361afdb3b.svg";